import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import FacilitatesTable from '../components/FacilitatesTable';

const Facilitates = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isFacilitatesModalOpen, setIsFacilitatesModalOpen] = useState(false);
  const [facilitatesImages, setFacilitatesImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.FACILITATES}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_FACILITATE,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsFacilitatesModalOpen(true);
              setFacilitatesImages([]);
            }}
          >
            Add New Facilitate
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_FACILITATE,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsFacilitatesModalOpen(true);
              setFacilitatesImages([]);
            }}
          >
            Add New Facilitate
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <FacilitatesTable
          isFacilitatesModalOpen={isFacilitatesModalOpen}
          setIsFacilitatesModalOpen={setIsFacilitatesModalOpen}
          facilitatesImages={facilitatesImages}
          setFacilitatesImages={setFacilitatesImages}
        />
      </Card>
    </>
  );
};

export default Facilitates;
